module.exports = __webpack_public_path__ + "img/737659b.jpg";